export function getApiBase() {
  const env = process.env.REACT_APP_API_URL;
  if (env && String(env).trim()) return String(env).replace(/\/$/, '');
  // Development: relative URLs → CRA proxy (setupProxy.js) → Express on 3020
  if (process.env.NODE_ENV !== 'production') return '';
  return '';
}

function readCookie(name) {
  if (typeof document === 'undefined') return '';
  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : '';
}

// CSRF token issued by the server as a readable cookie (double-submit pattern).
export function getCsrfToken() {
  return readCookie('XSRF-TOKEN');
}

const SAFE_METHODS = ['GET', 'HEAD', 'OPTIONS'];

export async function apiFetch(path, options = {}) {
  const base = getApiBase();
  const url = `${base}${path}`;
  const method = String(options.method || 'GET').toUpperCase();
  const headers = { ...(options.headers || {}) };
  if (!SAFE_METHODS.includes(method)) {
    const token = getCsrfToken();
    if (token) headers['X-XSRF-TOKEN'] = token;
  }
  const res = await fetch(url, { credentials: 'include', ...options, headers });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(
      data.error ||
        (res.status === 404 && !data.error
          ? 'This feature is temporarily unavailable. Refresh the page or try again shortly.'
          : `Could not complete the request (${res.status})`)
    );
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}
